import { api } from "@/lib/axios/axiosConfigs";
import { defineCancelApiObject } from "@/lib/axios/axiosUtils";
import { ENDPOINTS } from "@/constants/endpoints";

export const customerServices = {
  getProfile: async function (params, cancel = false) {
    const response = await api.request({
      url: `${ENDPOINTS.CUSTOMER}/${params.id}`,
      method: "GET",
      // retrieving the signal value by using the property name
      signal: cancel
        ? cancelApiObject[this.getProfile.name].handleRequestCancellation()
            .signal
        : undefined,
    });
    // returning the data
    return response.data;
  },
  updateProfile: async function (params, cancel = false) {
    const response = await api.request({
      url: `${ENDPOINTS.CUSTOMER}/${params.id}`,
      method: "PUT",
      data: params,
      // retrieving the signal value by using the property name
      signal: cancel
        ? cancelApiObject[this.updateProfile.name].handleRequestCancellation()
            .signal
        : undefined,
    });
    // returning the data
    return response.data;
  },
  //   bookingList: async function (params, cancel = false) {
  //     const response = await api.request({
  //       url: `${ENDPOINTS.CUSTOMER_BOOKING_LIST}/${params.id}`,
  //       method: "GET",
  //       // retrieving the signal value by using the property name
  //       signal: cancel
  //         ? cancelApiObject[this.bookingList.name].handleRequestCancellation()
  //             .signal
  //         : undefined,
  //     });

  //     // returning the data
  //     return response.data;
  //   },
  getUpcomingCustomerAppointment: async function (
    params,
    page,
    cancel = false
  ) {
    const response = await api.request({
      url: `${ENDPOINTS.CUSTOMER_BOOKING_UPCOMING_LIST}/${params.id}?page=${page}`,
      method: "GET",
      // retrieving the signal value by using the property name
      signal: cancel
        ? cancelApiObject[
            this.getUpcomingCustomerAppointment.name
          ].handleRequestCancellation().signal
        : undefined,
    });

    // returning the data
    return response.data;
  },
  getPastCustomerAppointment: async function (params, page, cancel = false) {
    const response = await api.request({
      url: `${ENDPOINTS.CUSTOMER_BOOKING_PAST_LIST}/${params.id}?page=${page}`,
      method: "GET",
      // retrieving the signal value by using the property name
      signal: cancel
        ? cancelApiObject[
            this.getPastCustomerAppointment.name
          ].handleRequestCancellation().signal
        : undefined,
    });

    // returning the data
    return response.data;
  },
  getFreeUpcomingCustomerAppointment: async function (
    params,
    page,
    cancel = false
  ) {
    const response = await api.request({
      url: `${ENDPOINTS.CUSTOMER_FREE_BOOKING_UPCOMING_LIST}/${params.id}?page=${page}`,
      method: "GET",
      // retrieving the signal value by using the property name
      signal: cancel
        ? cancelApiObject[
            this.getUpcomingCustomerAppointment.name
          ].handleRequestCancellation().signal
        : undefined,
    });

    // returning the data
    return response.data;
  },
  getFreePastCustomerAppointment: async function (
    params,
    page,
    cancel = false
  ) {
    const response = await api.request({
      url: `${ENDPOINTS.CUSTOMER_FREE_BOOKING_PAST_LIST}/${params.id}?page=${page}`,
      method: "GET",
      // retrieving the signal value by using the property name
      signal: cancel
        ? cancelApiObject[
            this.getPastCustomerAppointment.name
          ].handleRequestCancellation().signal
        : undefined,
    });

    // returning the data
    return response.data;
  },
  bookingListDetails: async function (params, cancel = false) {
    const response = await api.request({
      url: `${ENDPOINTS.CUSTOMER_BOOKING_LIST_DETAILS}/${params}`,
      method: "GET",
      // retrieving the signal value by using the property name
      signal: cancel
        ? cancelApiObject[
            this.bookingListDetails.name
          ].handleRequestCancellation().signal
        : undefined,
    });

    // returning the data
    return response.data;
  },
  customerreview: async function (params, cancel = false) {
    const response = await api.request({
      url: `${ENDPOINTS.REVIEW}`,
      method: "POST",
      data: params,
      // retrieving the signal value by using the property name
      signal: cancel
        ? cancelApiObject[this.customerReview.name].handleRequestCancellation()
            .signal
        : undefined,
    });

    // returning the data
    return response.data;
  },
  classesList: async function (params, page, cancel = false) {
    const response = await api.request({
      url: `${ENDPOINTS.CUSTOMER_CLASSES}/${params.id}?page=${page}`,
      method: "GET",
      // retrieving the signal value by using the property name
      signal: cancel
        ? cancelApiObject[this.classesList.name].handleRequestCancellation()
            .signal
        : undefined,
    });

    // returning the data
    return response.data;
  },
  classdetails: async function (params, cancel = false) {
    const response = await api.request({
      url: `${ENDPOINTS.CUSTOMER_CLASSES_DETAILS}/${params.id}?customer_id=${params.customer_id}`,
      method: "GET",
      // retrieving the signal value by using the property name
      signal: cancel
        ? cancelApiObject[this.classes.name].handleRequestCancellation().signal
        : undefined,
    });

    // returning the data
    return response.data;
  },
  paymentHistory: async function (params, cancel = false) {
    const response = await api.request({
      url: `${ENDPOINTS.CUSTOMER_PAYMENT_HISTORY}/${params}`,
      method: "GET",
      // retrieving the signal value by using the property name
      signal: cancel
        ? cancelApiObject[this.paymentHistory.name].handleRequestCancellation()
            .signal
        : undefined,
    });

    // returning the data
    return response.data.data;
  },
  changePassword: async function (params, cancel = false) {
    const response = await api.request({
      url: `${ENDPOINTS.CUSTOMER_CHANGE_PASSWORD}/${params.id}`,
      method: "PUT",
      data: params,
      // retrieving the signal value by using the property name
      signal: cancel
        ? cancelApiObject[this.changePassword.name].handleRequestCancellation()
            .signal
        : undefined,
    });

    // returning the data
    return response.data;
  },
  getPaymentHistory: async function (params, page, cancel = false) {
    const response = await api.request({
      url: `${ENDPOINTS.CUSTOMER_PAYMENT_HISTORY}/${params.id}?page=${page}`,
      method: "GET",
      data: params,
      // retrieving the signal value by using the property name
      signal: cancel
        ? cancelApiObject[
            this.getPaymentStatus.name
          ].handleRequestCancellation().signal
        : undefined,
    });

    // returning the data
    return response.data;
  },
  getTestimonials: async function (params, cancel = false) {
    const response = await api.request({
      url: `${ENDPOINTS.GET_TESTMONIALS}`,
      method: "GET",
      // retrieving the signal value by using the property name
      signal: cancel
        ? cancelApiObject[this.getTestimonials.name].handleRequestCancellation()
            .signal
        : undefined,
    });

    // returning the data
    return response.data;
  },
  slotBooking: async function (params, cancel = false) {
    const response = await api.request({
      url: `${ENDPOINTS.CUSTOMER_BOOK_SLOT}`,
      method: "POST",
      data: params,
      // retrieving the signal value by using the property name
      signal: cancel
        ? cancelApiObject[this.slotBooking.name].handleRequestCancellation()
            .signal
        : undefined,
    });

    // returning the data
    return response.data;
  },
  getSlotData: async function (params, cancel = false) {
    const response = await api.request({
      url: `${ENDPOINTS.CUSTOMER_GET_SLOT}/${params.id}`,
      method: "GET",
      // retrieving the signal value by using the property name
      signal: cancel
        ? cancelApiObject[this.fetchSlotData.name].handleRequestCancellation()
            .signal
        : undefined,
    });

    // returning the data
    return response.data;
  },
  getCourseSlotData: async function (params, cancel = false) {
    const response = await api.request({
      url: `${ENDPOINTS.GET_COURSE_SLOT_DATA}/${params.id}/${params.customer_id}`,
      method: "GET",
      // retrieving the signal value by using the property name
      signal: cancel
        ? cancelApiObject[
            this.getCourseSlotData.name
          ].handleRequestCancellation().signal
        : undefined,
    });

    // returning the data
    return response.data;
  },

  getCourseSlotRemainingPayment: async function (params, cancel = false) {
    const response = await api.request({
      url: `${ENDPOINTS.CLASS_REMAINING_PAYMENT_DETAIL_API}/${params.id}/${params.customer_id}`,
      method: "GET",
      // retrieving the signal value by using the property name
      signal: cancel
        ? cancelApiObject[
            this.getCourseSlotRemainingPayment.name
          ].handleRequestCancellation().signal
        : undefined,
    });

    // returning the data
    return response.data;
  },

  bookingGetSlotData: async function (params, cancel = false) {
    const response = await api.request({
      url: `${ENDPOINTS.BOOKING_GET_SLOT_AFTER_PAYMENT}/${params.id}`,
      method: "GET",
      // retrieving the signal value by using the property name
      signal: cancel
        ? cancelApiObject[
            this.bookingGetSlotData.name
          ].handleRequestCancellation().signal
        : undefined,
    });

    // returning the data
    return response.data;
  },
  classGetCourseSlotData: async function (params, cancel = false) {
    const response = await api.request({
      url: `${ENDPOINTS.CLASS_GET_SLOT_AFTER_PAYMENT}/${params.id}`,
      method: "GET",
      // retrieving the signal value by using the property name
      signal: cancel
        ? cancelApiObject[
            this.classGetCourseSlotData.name
          ].handleRequestCancellation().signal
        : undefined,
    });

    // returning the data
    return response.data;
  },

  storeBooking: async function (params, cancel = false) {
    const response = await api.request({
      url: `${ENDPOINTS.CUSTOMER_STORE_BOOKING}`,
      method: "POST",
      data: params,
      // retrieving the signal value by using the property name
      signal: cancel
        ? cancelApiObject[this.storeBooking.name].handleRequestCancellation()
            .signal
        : undefined,
    });

    // returning the data
    return response.data;
  },

  storeFreeBooking: async function (params, cancel = false) {
    const response = await api.request({
      url: `${ENDPOINTS.CUSTOMER_STORE_BOOKING_FREE}`,
      method: "POST",
      data: params,
      // retrieving the signal value by using the property name
      signal: cancel
        ? cancelApiObject[
            this.storeFreeBooking.name
          ].handleRequestCancellation().signal
        : undefined,
    });

    // returning the data
    return response.data;
  },

  customerCheckClassAvailable: async function (params, cancel = false) {
    const response = await api.request({
      url: `${ENDPOINTS.CUSTOMER_CHECK_CLASS_AVAILABLE}`,
      method: "POST",
      data: params,
      // retrieving the signal value by using the property name
      signal: cancel
        ? cancelApiObject[
            this.customerCheckClassAvailable.name
          ].handleRequestCancellation().signal
        : undefined,
    });

    // returning the data
    return response.data;
  },

  customerPaymentStatusUpdate: async function (params, cancel = false) {
    const response = await api.request({
      url: `${ENDPOINTS.CUSTOMER_PAYMENT_STATUS_UPDATE}`,
      method: "POST",
      data: params,
      // retrieving the signal value by using the property name
      signal: cancel
        ? cancelApiObject[
            this.customerPaymentStatus.name
          ].handleRequestCancellation().signal
        : undefined,
    });

    // returning the data
    return response.data;
  },

  customerRemainingPaymentStatusUpdate: async function (
    params,
    cancel = false
  ) {
    const response = await api.request({
      url: `${ENDPOINTS.CLASS_REMAINING_PAYMENT_API}`,
      method: "POST",
      data: params,
      // retrieving the signal value by using the property name
      signal: cancel
        ? cancelApiObject[
            this.customerRemainingPaymentStatusUpdate.name
          ].handleRequestCancellation().signal
        : undefined,
    });

    // returning the data
    return response.data;
  },

  getCustomerReview: async function (params, cancel = false) {
    const response = await api.request({
      url: `${ENDPOINTS.GET_CUSTOMER_REVIEW}/${params}`,
      method: "GET",
      //data: params,
      // retrieving the signal value by using the property name
      signal: cancel
        ? cancelApiObject[
            this.getCustomerReview.name
          ].handleRequestCancellation().signal
        : undefined,
    });

    // returning the data
    return response.data;
  },
};

// defining the cancel API object for ProductAPI
const cancelApiObject = defineCancelApiObject(customerServices);
